import { render, staticRenderFns } from "./recover.vue?vue&type=template&id=0654e11a&scoped=true"
import script from "./recover.vue?vue&type=script&lang=js"
export * from "./recover.vue?vue&type=script&lang=js"
import style0 from "./recover.vue?vue&type=style&index=0&id=0654e11a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0654e11a",
  null
  
)

export default component.exports